import React from 'react';
export function HowItWorks() {
  const steps = [{
    label: 'STEP 1',
    title: 'Pick a vibe. Place your art.',
    description: 'Modern, boho, gallery, café — every style is fresh AI.',
    image: 'https://cdn.magicpatterns.com/uploads/kuvhpBJrqqwQpVJTJiXBre/0x0ss_(44).png',
    bgColor: '#2E2640'
  }, {
    label: 'STEP 2',
    title: 'Generate in seconds.',
    description: 'AI creates a unique room around your artwork — never stock photos.',
    image: 'https://cdn.magicpatterns.com/uploads/kAdtYfzvMN7AqYX4MnF3aU/0x0ss_(43).png',
    bgColor: '#1F2937'
  }, {
    label: 'STEP 3',
    title: 'Download & showcase.',
    description: 'Perfect mockups for Etsy, Instagram, or your portfolio.',
    image: 'https://cdn.magicpatterns.com/uploads/m9ecTrprmXvzXnbhpMyQ4X/0x0ss_(47).png',
    bgColor: '#1A1A2E'
  }];
  return <section className="w-full bg-[#0A0A0F] py-24 lg:py-32" data-id="element-111">
      <div className="max-w-7xl mx-auto px-6" data-id="element-112">
        <div className="text-center mb-20" data-id="element-113">
          <span className="text-sm font-bold text-[#3B9EFF] tracking-widest uppercase" data-id="element-114">
            How it works
          </span>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mt-4 leading-tight tracking-tight" data-id="element-115">
            Three steps to stunning mockups
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12" data-id="element-116">
          {steps.map((step, index) => <div key={index} className="group" data-id="element-117">
              <div className="relative rounded-2xl overflow-hidden mb-6" style={{
            backgroundColor: step.bgColor
          }} data-id="element-118">
                <div className="aspect-[9/16] flex items-center justify-center p-6" data-id="element-119">
                  <img src={step.image} alt={step.title} className="w-full max-w-[280px] drop-shadow-2xl transform group-hover:scale-105 transition-transform duration-300" data-id="element-120" />
                </div>
              </div>

              <div className="space-y-3" data-id="element-121">
                <span className="text-xs font-bold text-[#3B9EFF] tracking-widest uppercase" data-id="element-122">
                  {step.label}
                </span>
                <h3 className="text-2xl font-bold text-white leading-tight" data-id="element-123">
                  {step.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-124">
                  {step.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}